import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SearchIcon from '@mui/icons-material/Search';
import {Link, useNavigate, useParams} from "react-router-dom";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getDistrictUsers} from "../store/logIn";
import {useEffect, useState} from "react";
import {InputAdornment, OutlinedInput} from "@mui/material";

// Markaziy bo'lim uchun - barcha tuman/shahar bo'limlari (region param ixtiyoriy)
// /districts/ - barcha tumanlar
// /region-districts/:regionId - biror viloyatning tumanlari
function Districts(props) {
    const {t, i18n} = useTranslation()
    const navigate = useNavigate()
    const params = useParams()
    const [districts, setDistricts] = useState([])
    const [search, setSearch] = useState('')

    useEffect(()=>{
        props.getDistrictUsers(params.regionId || null)
    }, [params.regionId])

    useEffect(()=>{
        setDistricts(props.district_users)
    }, [props.district_users])

    const toBack = () => {
        navigate(-1);
    }

    const filtered = districts.filter(item =>
        item.user_name ? item.user_name.toLowerCase().includes(search.toLowerCase()) : true
    )

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto',
                    }}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon />} onClick={toBack}>
                            {t('back')}
                        </Button>
                        <div className="my-3">
                            <OutlinedInput
                                size="small"
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                placeholder={t('search_district')}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <div className="row">
                            {filtered.map((item, index) => (
                                <div className="col-lg-2" key={index}>
                                    <Link to={'/district-cabinet/'+item.id}>
                                        <div className="card">
                                            <div className="card-header">
                                                <LocationOnIcon className={'icon-card'}/>
                                            </div>
                                            <div className="card-body">
                                                <h3 className={'text-center mb-0 text-uppercase'}>{item.user_name}</h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default connect(props => props.login, {getDistrictUsers})(Districts)
